import { useSelector } from "react-redux";
import { RootState } from "../../store";
import classes from "./Header.module.css";

const BASE = "/api";

const Header = () => {
  const { pod, resourceName } = useSelector((state: RootState) => state.pod);

  return (
    <div className={classes.container}>
      {pod?.logoImage && (
        <img
          className={classes.logo}
          src={`${BASE}${pod.logoImage}?${pod.updateTime}&tenantId=${resourceName}`}
          alt=''
        />
      )}
    </div>
  );
};

export default Header;
